import React, { useState } from 'react';
import { Citation } from '../services/chatService';
import { PDFPreview } from './PDFPreview';

interface CitationPanelProps {
  citations: Citation[];
}

export const CitationPanel: React.FC<CitationPanelProps> = ({ citations }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleViewSource = (source: string) => {
    // Check if it's a presigned S3 URL (contains X-Amz-Algorithm)
    const isS3Presigned = source.includes('X-Amz-Algorithm');
    
    // Check if it's a direct PDF file (not SharePoint)
    const isPdfFile = source.includes('.pdf') && !source.includes('sharepoint.com');
    
    if (isS3Presigned || isPdfFile) {
      setPreviewUrl(source);
    } else {
      window.open(source, '_blank');
    }
  };

  return (
    <>
      <div className="mt-2 p-3 bg-gray-50 dark:bg-gray-700 rounded border dark:border-gray-600">
        <h4 className="text-sm font-semibold mb-2 text-gray-700 dark:text-gray-300">Sources:</h4>
        <div className="space-y-2">
          {citations.map((citation) => (
            <div key={citation.number} id={`citation-${citation.number}`} className="text-sm scroll-mt-24">
              <div className="flex items-center gap-2">
                <span className="font-medium text-gray-900 dark:text-white">[{citation.number}]</span>
                <span className="text-gray-600 dark:text-gray-400">
                  Score: {(citation.score * 100).toFixed(1)}%
                </span>
                {citation.source && (
                  <button
                    onClick={() => handleViewSource(citation.source)}
                    className="text-blue-600 dark:text-blue-400 hover:underline text-xs"
                  >
                    View Source →
                  </button>
                )}
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-300 mt-1 line-clamp-3">
                {citation.text}
              </div>
            </div>
          ))}
        </div>
      </div>
      {previewUrl && <PDFPreview url={previewUrl} onClose={() => setPreviewUrl(null)} />}
    </>
  );
};
